import React, { useMemo } from 'react';
import PriceCell from 'components/ServicesTables/common/cells/PriceCell';
import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';
import SimpleValueCell from 'components/ServicesTables/common/cells/SimpleValueCell';
import { translate } from 'components/Translation';

interface IJawazakColumnProps {
	catalogEntryView: types.ecommerce.CatalogEntryView;
}

const JawazakColumn = ({ catalogEntryView }: IJawazakColumnProps) => {
	const attributes = catalogEntryView?.attributes || [];
	const prices = catalogEntryView?.price || [];

	const price = useMemo(() => {
		return {
			offer: prices.find((singlePrice) => singlePrice.usage === 'Offer'),
			display: prices.find((singlePrice) => singlePrice.usage === 'Display'),
		};
	}, [prices]);

	const duration = useMemo(() => {
		const value = extractAttributeValue({ attributes }, CustomAttribute.DURATION);
		if (Number(value) === 1) {
			return translate('jawazak.table.day', value);
		}
		return translate('jawazak.table.days', value);
	}, [attributes]);

	return (
		<>
			<SimpleValueCell
				value={duration}
				backgroundColor={'backgroundGray'}
				title={translate('jawazak.table.validity')}
			/>
			<PriceCell
				price={price?.display.value || '-'}
				currency={price?.display.currency || ''}
				offerPrice={price.offer}
			/>
		</>
	);
};

export default JawazakColumn;
